import { api } from "./api";

export const gam = {
    levels: () => api.get("/gamification/levels").then((r) => r.data),
    level: (userId) => api.get(`/gamification/level/${userId}`).then((r) => r.data),
    passport: (userId) => api.get(`/gamification/passport/${userId}`).then((r) => r.data),
    challenges: () => api.get("/gamification/challenges").then((r) => r.data),
    timeline: (limit = 25) => api.get(`/gamification/timeline?limit=${limit}`).then((r) => r.data),
    shareLevelup: (level_slug) => api.post("/gamification/share-levelup", { level_slug }).then((r) => r.data),
};

// Static fallback so the UI can render before the /levels call resolves.
export const STATIC_LEVELS = [
    { slug: "rookie_explorer", name: "Rookie Explorer", min_xp: 0, color: "#9CA3AF" },
    { slug: "weekend_wanderer", name: "Weekend Wanderer", min_xp: 100, color: "#65A30D" },
    { slug: "trail_regular", name: "Trail Regular", min_xp: 300, color: "#0EA5E9" },
    { slug: "local_guide", name: "Local Guide", min_xp: 700, color: "#F26A2E" },
    { slug: "adventure_builder", name: "Adventure Builder", min_xp: 1500, color: "#A855F7" },
    { slug: "regional_expert", name: "Regional Expert", min_xp: 3000, color: "#DC2626" },
    { slug: "legendary_explorer", name: "Legendary Explorer", min_xp: 6000, color: "#FCD34D" },
];

export function levelColor(slug) {
    return STATIC_LEVELS.find((l) => l.slug === slug)?.color || "#F26A2E";
}
